const config = Object.freeze({
  API_BASE_PATH: process.env.REACT_APP_API_BASE_PATH,
});

export default config;
